/** Длительность демо-доступа после регистрации клуба (дней). */
export const TRIAL_DAYS = 7;
